import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "300",
  height: "279"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "jfsxc9emra",
        x1: "-4.623%",
        x2: "86.992%",
        y1: "93.245%",
        y2: "21.035%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#D8E5C4",
          "stop-opacity": ".25"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#D8E5C4"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#jfsxc9emra)",
      "fill-rule": "evenodd",
      d: "M157.617 20.394 275.03 127.827c15.917 14.564 24.97 35.061 24.97 56.536V279h-51.724v-94.637c0-7.158-3.018-13.99-8.323-18.845L122.539 58.085c-9.906-9.064-25.172-9.064-35.078 0L0 138.11V68.324l52.383-47.93c29.718-27.192 75.516-27.192 105.234 0",
      transform: "matrix(-1 0 0 1 300 0)"
    }, null, -1)
  ])))
}
export default { render: render }